/* Vuex store */
import Vue from 'vue';
import Vuex from 'vuex';

// MODULES /////////////////////////////////////////////////////////////////////
import global from './modules/global';
import authServicesPoints from './modules/authServicesPoints';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    authServicesPoints,
  },
  strict: !process.env.DEBUG_MODE,
});



// WEBPACK FOOTER //
// ./src/store/index.js